import React from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import SpecTable from 'components/display/SpecTable'

import styles from './styles.scss'

const SuccessStatus = props => {
    const msg = props.result === "Pass" ? <code className={styles.success}>Pass</code> : <code className={styles.error}>Fail</code>
    return <SpecTable moduleName='nvqualSummaryStatus' moduleData={{ msg }} />    
}

SuccessStatus.propTypes = {
    result: PropTypes.string.isRequired,
}

export default CSSModules(styles)(SuccessStatus)
